<template>
<div>
     <HeadDetailsGama  @nextstatus="$emit('nextstatus')" :btnCanceSave="!flDisable" v-on:save="save" :titleHead="'Lista de Chamados'"></HeadDetailsGama>
    <div>
        <div class="Sub-Titulo">Mão de Obra</div>
        <div class="label-valor-mao-obra">Valor total da mão de obra</div>
        <p class="label-details"> {{ calcularTotal}}</p>
        <!-- <input class="input-valor-mao-obra form-control" :value="calcularTotal" disabled/> -->
    </div>
     <div class="tabela-insumos mt-2">
        <div class="tituloTabela">
            Insumos
        </div>
        <div class="button-add">
            <b-button :disabled="flDisable" class="button-add-insumo Insumo-add-ajuste" id="show-btn" @click="openPoupInsumo"><i class="fas fa-plus icone"></i> Adicionar Insumo</b-button>
        </div>
    </div>

    <div class="tabela-insumos-table">
        <Tables class="Table-Corre" ref="tableGrids"
            :columns="head"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="GetByOccurenceById"
            >
                <tr  v-for="data in dataOccourenceInput" v-bind:key="data.id">
                    <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.insumo.name" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.dataRegistroInsumoFormatada" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.quantidadeMaterial" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.valorFormatado" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="data.valorTotalFormatado" />
                    <TableColumn :IsDocumentActions="true"  :IsActionsButtons="true" :HasEdit="!flDisable" :HasChange="false" :HasDocumentDelete="!flDisable" :HasDelete="false"  :newEditGama="true" slot-scope="" v-on:Edit="openeditinsumo(data)" v-on:Delete="deleteinsumos(data)" :status="[1,0][data.status]" class="d-flex justify-content-center"/>
                </tr>
                <tr class="total-table">
                    <td class="custo-total-table" colspan="5">CUSTO TOTAL:</td>
                    <td class="text-center custo-total-table">{{calcularTotal}}</td>
                </tr>
        </Tables>

    </div>

  <b-modal ref="bv-modal-example" id="bv-modal-example" size = "lg" hide-footer>
    <template #modal-title>
      <div class="titulo-modal">ADICIONAR INSUMO</div>
    </template>

    <div class="conteudo-modal-insumo">
        <!-- <div class="barra-pesquisa-modal">
        </div> -->

        <div class="selecioneArquivo-modal">
            <div>Selecione o arquivo que deseja enviar</div>
        </div>
        <div class="arquivosModal">
            <div class="searchcosts">
                <div class="input-pesquisa">
                    <input v-model="searchinsumos" class="input-pesquisar" placeholder="Pesquisar.."/>
                </div>
                <div class="button-pesquisa">
                    <b-button class="button-pesquisar" @click="buscarinsumos"><i class="fas fa-search"></i> Buscar</b-button>
                </div>
            </div>
            <div class="cadastreArquivo-modal">
                <div @click="showModal" style="cursor:pointer"><i class="far fa-plus-square"></i> Cadastrar Insumos</div>
            </div>
        </div>
        <div class="listtypecosts">
            <div v-for="(insumo, index) in dataInsumos" :key="index">
                <div class="arquivos-seleciona">
                    <div class="card-arquivo-insumo">
                        <div class="img-ajuste-margem">
                            <img src="/static/img/icone_insumo.png" class="img-insumo">
                        </div>
                        <div class="nomeDoInsumo">
                            <div>#{{insumo.codigo}} - {{insumo.name}}</div>
                        </div>
                        <inputbutton ref="inputbutton" :id="insumo.id"></inputbutton>

                    </div>
                </div>
            </div>
        </div>

        <div class="container-cancela-casdatra-modal">
            <div class="cancela">
                <b-button @click="fecharModalAdd" class="button-modal-novo-insumo">CANCELAR</b-button>
            </div>
            <div class="cadastra">
                <b-button class="button-modal-novo-insumo-confirm" @click="saveinsumos">CADASTRAR</b-button>
            </div>
        </div>
    </div>

  </b-modal>

  <b-modal ref="bv-edit-insu" id="bv-edit-insu" size = "sm" hide-footer centered>
    <template #modal-title>
      <div class="titulo-modal">EDITAR INSUMO</div>
    </template>

    <div class="conteudo-modal-insumo">
        <div class="form-modal">
            <label class="label-modal">Quantidade</label>
            <input type="number"  class="form-control text-left" v-model="formeditinsumo.quantidadeMaterial">
        </div>
        <div class="form-modal">
            <label class="label-modal">Valor</label>
            <money class="form-control form-control-10 text-right"
                          v-bind="integerFormat"
                         :placeholder="'R$ 0,00'"
                          prefix="R$ "
                          v-model="formeditinsumo.valor"
                          />
        </div>
        <div class="buttons-modal-edit">
                <b-button @click="fecharModalEditInsu" class="button-modal-edit-insumo">CANCELAR</b-button>
                <b-button @click="editInsumos" class="button-modal-edit-insumo-confirm">SALVAR</b-button>
        </div>
    </div>
    </b-modal>
    <b-modal ref="my-modal" hide-footer centered hide-header-close >
        <template #modal-title>
            <div class="titulo-modal">CADASTRAR NOVO INSUMO</div>
        </template>
        <div class="titulo-modal-novo-insumo" >Digite o nome do novo insumo</div>
        <div class="input-modal-novo-insumo"><input class="input-pesquisar form-control" v-model="formNewIput.name"></div>

        <div class="container-cancela-casdatra-modal">
            <div class="cancela">
                <b-button class="button-modal-novo-insumo" @click="back">CANCELAR</b-button>
            </div>
            <div class="cadastra">
                <b-button class="button-modal-novo-insumo-confirm"  @click="newInput">CADASTRAR</b-button>
            </div>
        </div>
    </b-modal>

</div>
</template>
<script>
import inputCosts from './inputCosts'
export default inputCosts
</script>
<style scoped>
.icone-check{
    margin-bottom: 3%;
}
.icone{
    margin-top: 5px;
    padding-right: 7px;
}

.img-ajuste-margem{
    margin-top: 2px;
    padding-right: 7px;
}
.v-money{
    text-align: left !important;
}
.buttons-modal-edit{
    display: flex;
    width: 100%;
    gap: 1rem;
}

.Sub-Titulo{
    margin-top: 1rem;
    font: normal normal bold 15px/24px Segoe UI;
    color: #008148;
}
.form-modal{
    /* margin-bottom: 15px; */
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}
.label-modal{
    font-size: 14px;
    font-weight: bold;
    line-height: 5px;
    font-family: 'Segoe UI';
}
.button-save {
     /* height: 50px;
     background: #008148;
     color: white;
     font-weight: bold;
     border: none;
    width: 40%; */
    width: 60%;
    height: 40px;
    border-radius: 10px;
    font: normal normal 600 14px/24px Segoe UI;
    margin-top: 1.6rem;
    background: #008148;
    color:#ffffff;
}
.button-can{
    height: 50px;
    font-weight: bold;
    width: 40%;
    background: #DEDEDE;
    border: 1px solid #DEDEDE;
}

.label-valor-mao-obra{
    margin-top: 0.3rem;
    font: normal normal 600 15px/24px Segoe UI;
    color: #606160;
}

.input-valor-mao-obra{
    width: 24rem;
    margin-top: 0.5rem;
    height: 2rem;
    border: 1px solid #b9b6b6;
    border-radius: 5px;
    padding-left: 0.5rem;
}

.tabela-insumos {
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "tituloTabela button-add"; */
    display: flex;
    flex-direction: column;
}

.tituloTabela {
    grid-area: tituloTabela;
    margin-top: 0.3rem;
    font: normal normal bold 15px/24px Segoe UI;
    color: #008148;
    display: flex;
    align-items: initial;
}

.button-add {
    display: flex;
}

.btn-secondary{
    color: rgb(80, 79, 79);
    width: 10rem;
    /* margin-left: -2rem; */
    font: normal normal 600 14px/24px Segoe UI;
    background-color: #D8D8D8;
    border-color: transparent ;
    border-radius: 5px;
}

.titulo-modal{
    color:white;
    font: normal normal 600 18px/24px Segoe UI;
    display: flex;
    align-items: center;
}

.barra-pesquisa-modal {
  display: grid;
  grid-template-columns: 1fr 0.4fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "input-pesquisa button-pesquisa";
}

.input-pesquisa {
    grid-area: input-pesquisa;
    width: 100%;
 }

.input-pesquisar{
    width: 100%;
    margin-top: 0.5rem;
    height: 2rem;
    border: 1px solid #b9b6b6;
    border-radius: 5px;
    padding-left: 0.5rem;
}

.button-pesquisa {
    grid-area: button-pesquisa;
    display: flex;
    width: 100%;
 }
 .button-pesquisar{
    display: flex;
    border-radius: 8px;
    width: 90%;
    height: 32px;
    margin-top: 7px;
    font: normal normal 600 16px/24px Segoe UI;
    background-color: #008148;
    color: #ffffff;
    width: 35%;
    align-items: center;
    justify-content: center;
    gap:0 1rem;
}

.arquivosModal {
    /* margin-top: 1rem; */
    display: flex;
    gap: 0px 0px;
  /* grid-template-columns: 1fr 0.7fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  grid-template-areas:
    "selecioneArquivo-modal cadastreArquivo-modal"; */
}

.selecioneArquivo-modal{
    grid-area: selecioneArquivo-modal;
    font: normal normal 600 15px/24px Segoe UI;
    color: #008148;
    display: flex;

}

.cadastreArquivo-modal {
    grid-area: cadastreArquivo-modal;
    font: normal normal 600 15px/24px Segoe UI;
    color: #008148;
    display: flex;
    justify-content: end;
    padding: 0.5rem 0;
    width: 30%;
 }

 .arquivos-seleciona{
    height: 4rem;
    width: 100%;
    margin-top: 1rem;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #0000000F;
    border-radius: 5px;
    padding: 10px;
    opacity: 1;
 }
.card-arquivo-insumo {
  display: grid;
  grid-template-columns: 0.3fr 1fr 0.5fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "icone nomeDoInsumo button-add-insumo";
}

.icone { grid-area: icone; }

.img-insumo{
width: 40px;
}
.nomeDoInsumo {
    grid-area: nomeDoInsumo;
    font-weight: bold;
    font-family: 'Segoe UI';
    display: flex;
    align-items: center;
}

.button-add-insumo {
    justify-content: flex-end;
    display: flex;
    align-items: center;
}

.Insumo-add-ajuste{
    margin-top: 0.3rem;
    background-color:#008148;
    color: #ffffff;
}

.button-adicionar{
    margin-top: 0.3rem;
    height: 30px;
    width: 80px;
    transition: all .3s ease-in-out;
}

.button-animation{
    display: flex;
    justify-content: center;
    margin-top: 0.3rem;
    height: 30px;
    width: 30px;
    transition: all .3s ease-in-out;
}

.button-adicionar:after {
            transform: (40%);
            width: 20px;
            /* Scaling button to 0.98 to its original size */
            box-shadow: 3px 2px 22px 1px rgba(240, 105, 105, 0.24);
            /* Lowering the shadow */
        }
.button-adicionar:focus  {
    height: 25px;
    border-radius: 30px;
    width: 20px;
    transition: all 700ms cubic-bezier(0.2, 0, 0, 0.8);
}

.tabela-insumos-table{
    width: 100%;
    margin-top: 1rem;
}

.total-table{
    background-color: #D8D8D8;
    font-family: 'Segoe UI';
    font-size: 15px;
    font-weight: bold;
}

.custo-total-table{
    background-color: #D8D8D8;
    color: #025e33;
    font-weight: bold;
}
.titulo-modal-novo-insumo{
    font: normal normal 600 15px/24px Segoe UI;
    color: #606160;
    width: 100%;
    text-align: center;
}

.input-modal-novo-insumo{
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 5px;
}

.container-cancela-casdatra-modal {
  margin-left: 1.2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "cancela cadastra";
}

.cancela {
    grid-area: cancela;
    display: flex;
    justify-content: center;
 }

.cadastra {
    grid-area: cadastra;
    display: flex;
    justify-content: center;
}
.button-modal-edit-insumo{
    width: 45%;
    height: 40px;
    border-radius: 10px;
    font: normal normal 600 14px/24px Segoe UI;
}

.button-modal-edit-insumo-confirm{
    width: 45%;
    height: 40px;
    border-radius: 10px;
    font: normal normal 600 14px/24px Segoe UI;
    background-color: #008148;
    color:#ffffff;
}

.button-modal-novo-insumo{
    width: 60%;
    height: 40px;
    border-radius: 10px;
    font: normal normal 600 14px/24px Segoe UI;
    margin-top: 1.6rem;
}

.button-modal-novo-insumo-confirm{
    width: 60%;
    height: 40px;
    border-radius: 10px;
    font: normal normal 600 14px/24px Segoe UI;
    margin-top: 1.6rem;
    background-color: #008148;
    color:#ffffff;
}

.conteudo-modal-insumo{
  /* padding-left: 45px; */
  /* padding-right: 45px; */
  padding-top: 5px;
  display: flex;
  flex-direction: column;
  gap:1rem;
}

.searchcosts {
    display: flex;
    width: 70%;
    gap: 1rem;
}

.listtypecosts{
    height: 60vh;
    overflow-y: auto;
}

.listtypecosts::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 15px;
}
.listtypecosts::-webkit-scrollbar {
    width: 10px;
    height: 10px;
     border-radius: 9px;
    background: #F4F4F4;
}
.listtypecosts::-webkit-scrollbar-thumb {
    background: rgb(192, 193, 192);
    border-radius: 9px;
}

.Table-Corre{
    font-family:'Segoe UI';
}

.label-details{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;
}

@media (max-width: 1444px) {
    .listtypecosts {
        height: 50vh;
        overflow-y: auto;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/InputCosts/inputCosts.vue